/**
 * Center the drag overlay on the cursor. Uses the overlay's measured size when
 * available (important for a small image ghost vs a full-size block).
 */
export const snapOverlayCenterToCursor = ({
  activatorEvent,
  draggingNodeRect,
  overlayNodeRect,
  transform,
}) => {
  if (!draggingNodeRect || !activatorEvent) return transform;

  const coords = coordinatesFromEvent(activatorEvent);
  if (!coords) return transform;

  const offsetX = coords.x - draggingNodeRect.left;
  const offsetY = coords.y - draggingNodeRect.top;

  const width = overlayNodeRect?.width ?? draggingNodeRect.width;
  const height = overlayNodeRect?.height ?? draggingNodeRect.height;

  return {
    ...transform,
    x: transform.x + offsetX - width / 2,
    y: transform.y + offsetY - height / 2,
  };
};

function coordinatesFromEvent(event) {
  if (!event) return null;
  if ('clientX' in event && typeof event.clientX === 'number') {
    return { x: event.clientX, y: event.clientY };
  }
  const touch = event.touches?.[0] || event.changedTouches?.[0];
  if (touch) return { x: touch.clientX, y: touch.clientY };
  return null;
}
